<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import Constants from "@/Constants";
import { goBack } from "@/NavigationHelper";
import {
  getKennungValueDisplay,
  getKennungValue,
  getKennungTitle,
} from "@/DataHelper";
import { mountedBase, onSave, BaseSetup } from "@/DataLoaderStatic";
import { checkBegriff } from "@/local";
import AUApi from "@/api";

const emit = defineEmits<{
  back: [];
  calculated: [data?: any];
}>();

const letzteBuchung = ref<string>("");
const letzteBuchungUm = ref<string>("");
const letzteBuchungAic = ref<string>("");
let showMobil = ref<boolean>(false);
let showZeitzone = ref<boolean>(false);

declare interface StempelEditBDEUiData extends DataPageUIData {
  taetigkeit?: string;
  auftrag?: string;
  kst?: string;
}

const pageParams: DataPageParameter = {
  backOnSave: true,
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "WEB_BDE_aendern",
  bewegungsdaten: true,
  emitBack: () => emit("back"),
};

const uiData = reactive<StempelEditBDEUiData>(
  BaseSetup<DataPageParameter, StempelEditBDEUiData>(pageParams),
);

onMounted(async () => {
  uiData.showLoading = true;
  const zeitzone = checkBegriff("PZE_Web_Zeitzone_Nacherfassen");
  if (zeitzone) {
    showZeitzone.value = true;
  }
  await mountedBase(uiData, pageParams);
  if (!uiData.showLoading && uiData.data!) {
    letzteBuchung.value = getKennungValueDisplay(
      uiData.data[0],
      "BDE",
      uiData.columns,
    );
    letzteBuchungUm.value = getKennungValueDisplay(
      uiData.data[0],
      "Uhrzeit",
      uiData.columns,
    );
    letzteBuchungAic.value = getKennungValue(
      uiData.data[0],
      "BDEAIC",
      uiData.columns,
    );
    if (Constants.isMobile) {
      const auftragHandy = getKennungTitle("Auftrag_Handy", uiData.columns);
      if (auftragHandy) {
        showMobil.value = true;
      }
    }
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});
async function save() {
  const aicAbfAll = 0;

  await onSave(
    uiData,
    pageParams,
    aicAbfAll,
    "",
    undefined,
    0,
    true,
    pageParams.varUebergabe,
  );
  emit("calculated");
}
</script>
<template>
  <v-card :loading="uiData.showLoading">
    <v-card-text v-if="uiData.initialized" class="pa-2">
      <EditTimePicker kennung="PHYS_ZEITPUNKT" />
      <EditComboBox v-if="showZeitzone" kennung="BEW_ZEITZONE" />
      <EditComboBox
        v-model="uiData.auftrag"
        kennung="INSTRUCTION"
        :queryZeitbereich="uiData.zeitbereich"
      />
      <EditComboBox
        v-model="uiData.taetigkeit"
        kennung="ACTIVITY"
        :queryZeitbereich="uiData.zeitbereich"
      />
      <EditComboBox
        v-model="uiData.kst"
        kennung="COST CENTRE"
        :queryZeitbereich="uiData.zeitbereich"
      />
      <EditTextArea :auto-grow="true" kennung="MEMO" />
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <CommonBaseButtons
        :backVisible="false"
        :deleteVisible="false"
        :createVisible="false"
        :refreshVisible="false"
        :saveVisible="true"
        @back="emit('back')"
        @save="save"
      ></CommonBaseButtons>
    </v-card-actions>
  </v-card>
</template>
